export default __webpack_public_path__ + "static/media/jasonseife.c7cb9c7b.png";